/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePaymentMethodDto } from '../../models/api-response-payment-method-dto';
import { PaymentMethodDto } from '../../models/payment-method-dto';

export interface CreatePaymentMethod$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PaymentMethodDto
}

export function createPaymentMethod(http: HttpClient, rootUrl: string, params: CreatePaymentMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePaymentMethodDto>> {
  const rb = new RequestBuilder(rootUrl, createPaymentMethod.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePaymentMethodDto>;
    })
  );
}

createPaymentMethod.PATH = '/v1/api/payment-methods';
